module.exports = __webpack_public_path__ + "img/tixing.ea20fb1e.png";